import { PAN_NUMBER_REGEX } from '../../../../utils/constants/regex';
import * as yup from 'yup';

export const panSchemaWithNoValidation = yup.object({
  panNumber: yup.string(),
  uploadedPanFile: yup.object({
    shortUrl: yup.string(),
    url: yup.string(),
  }),
});

export const panSchemaWithValidations = yup.object({
  panNumber: yup
    .string()
    .required('PAN card number is required')
    .length(10, 'PAN number should be 10 characters')
    .matches(
      PAN_NUMBER_REGEX,
      'Please enter valid PAN card number'
    ),
  uploadedPanFile: yup.object({
    shortUrl: yup
      .string()
      .required('Please upload PAN card'),
    url: yup.string().required('Please upload PAN card'),
  }),
});

export const panSchemaWithCheckbox = yup.object({
  selectPANCheckboxOption: yup.boolean().default(false),
  panDetails: panSchemaWithNoValidation.when(
    'selectPANCheckboxOption',
    ([selectPANCheckboxOption], schema) => {
      return selectPANCheckboxOption
        ? schema
        : schema.concat(panSchemaWithValidations);
    }
  ),
});
